const ACTIONS = Object.freeze({
  AUTH_USER: 'AUTH_USER',
  LOGOUT_USER: 'LOGOUT_USER',
  SET_ERROR: 'SET_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  FETCH_SERVICES: 'FETCH_SERVICES',
  FETCH_APPOINTMENTS: 'FETCH_APPOINTMENTS',
  CREATE_APPOINTMENT: 'CREATE_APPOINTMENT',
  SELECTED_SERVICE: 'SELECTED_SERVICE',
});

export default ACTIONS;
